import { BuiltInErrorType } from './constants';
import { ErrorBase } from './error-base';
var PlayerError = /** @class */ (function () {
    function PlayerError() {
    }
    PlayerError.CustomError = function (config) {
        return new ErrorBase(BuiltInErrorType.Custom, config);
    };
    /**
     * 生成原生错误对象，type=11
     *
     * @public
     * @static
     * @param {ErrorConfig} config
     */
    PlayerError.NativeError = function (config) {
        return new ErrorBase(BuiltInErrorType.Native, config);
    };
    /**
     * 生成介质网络错误对象，type=16，code分配规则如下：
     * 0-99: 预留为core层面或原生video网络错误
     * 100-199: 预留为hlsjs网络错误
     * 200-299: 预留为flvjs网络错误
     * 300-399: 预留为demux内核网络错误
     * 400-499: 预留为wasm内核网络错误
     * 500-599: 预留为rtc内核网络错误
     * 600-699: 预留为electron内核网络错误
     * 700-999: reserved
     * @public
     * @static
     * @param {ErrorConfig} config
     */
    PlayerError.NetworkError = function (config) {
        return new ErrorBase(BuiltInErrorType.Network, config);
    };
    /**
     * 生成加密错误对象，type=90
     *
     * @public
     * @static
     * @param {ErrorConfig} config
     */
    PlayerError.EncryptionError = function (config) {
        return new ErrorBase(BuiltInErrorType.Encryption, config);
    };
    return PlayerError;
}());
export { PlayerError };
export { ErrorTypeCodeMap, MediaElementNativeDetail } from './constants';
export { ErrorBase, BuiltInErrorType as TpCoreError };
